export enum TextBlockTitleVariant {
  H1 = 'h1',
  H2 = 'h2',
}

export enum TextBlockSubtitleVariant {
  H3 = 'h3',
  H4 = 'h4',
}

export enum TextBlockAlign {
  LEFT = 'left',
  CENTER = 'center',
}

export enum TextBlockTitleGrid {
  COL_12 = 'col-12',
  COL_8 = 'col-8',
}

export enum TextBlockParagraphGrid {
  COL_12 = 'col-12',
  COL_10 = 'col-10',
  COL_8 = 'col-8',
}

export enum TextBlockCheckListItemType {
  CHECK = 'check',
  PAW = 'paw',
  HORSE = 'horse',
}
